import { useQuery, useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";
import { useLoading } from "../../context/loadingContext";
import Swal from "sweetalert2";

const apiSetAgendamiento = async (params) => {

    let paramsConsulta = {
        idContrato: params?.idContrato,
        hora_id: params?.hora_id,
        agen_fecha: params?.agen_fecha,
        agen_usuario_agenda: params?.agen_usuario_agenda,
        telefono_cliente: params?.telefono_cliente,
        origen: params?.origen,
        rut: params?.rut
    }

    const { data } = await clienteAxios.post("/sucursalVirtual/integracionAtec/registrarAgendamiento", paramsConsulta);

    return data;
};

const useSetAgendamiento = (params) => {
    const { setLoading, removeLoading } = useLoading();

    return useMutation(apiSetAgendamiento, {
        onSuccess: (response) => {
           /*  if (response.success.descripcionRespuesta.error) {

                let mensajeError = response.success.descripcionRespuesta.error.mensaje.slice(0, - 1)
                Swal.fire({
                    icon: "error",
                    title: mensajeError,
                    html: `<p></p>`,
                    confirmButtonText: 'Volver',
                    focusConfirm: false,
                    iconColor: 'red',
                    width: '40rem',
                    customClass: {
                        popup: 'containerSwal',
                        title: 'titleSwal',
                        closeButton: '...',
                        icon: 'iconSwal',
                        confirmButton: 'buttonSwal',
                        denyButton: '...',
                        cancelButton: '...',
                    }
                });
            } */
            removeLoading({
                id: "setAgendamiento"
            });
        },
        onError: (error) => {
            removeLoading({
                id: "setAgendamiento"
            });
            Swal.fire({
                icon: "error",
                title: error.response.data.error.detalleRespuesta,
                html: `<p></p>`,
                confirmButtonText: 'Volver',
                focusConfirm: false,
                iconColor: 'red',
                width: '40rem',
                customClass: {
                    popup: 'containerSwal',
                    title: 'titleSwal',
                    closeButton: '...',
                    icon: 'iconSwal',
                    confirmButton: 'buttonSwal',
                    denyButton: '...',
                    cancelButton: '...',
                }
            });
        },
        onMutate: () => {
            setLoading({
                id: "setAgendamiento",
                message: "Procesando petición...",
            });
        },
    });

    return result;
};

export default useSetAgendamiento